import { create } from 'zustand';

// Determine initial theme from localStorage or system preference
const getInitialDarkMode = () => {
  if (typeof window === 'undefined') return true;

  const stored = window.localStorage.getItem('theme:dark');
  if (stored !== null) {
    return stored === 'true';
  }

  return window.matchMedia?.('(prefers-color-scheme: dark)')?.matches ?? true;
};

const useThemeStore = create((set) => ({
  darkMode: getInitialDarkMode(),

  setDarkMode: (value) => {
    set({ darkMode: value });
    if (typeof window !== 'undefined') {
      window.localStorage.setItem('theme:dark', value ? 'true' : 'false');
    }
  },

  toggleDarkMode: () =>
    set((state) => {
      const next = !state.darkMode;
      if (typeof window !== 'undefined') {
        window.localStorage.setItem('theme:dark', next ? 'true' : 'false');
      }
      return { darkMode: next };
    }),
}));

export default useThemeStore;
